import cn from 'classnames';
import { VoiceChannelMember } from 'src/provider/VoiceChannel';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';
import { MemberContent } from './MemberContent';
import { MemberInfoContent } from './MemberInfoContent';
import { TopAbsoluteButtons } from './TopAbsoluteButtons';
import { MemberCard } from './styles';
import { useMemberVariables } from './useMemberVariables';

type Props = {
  connected: boolean;
  member: VoiceChannelMember;
  isFromNav?: boolean;
  aloneMember?: boolean;
  onClick?: () => void;
};

export const VoiceChannelMemberGridItem = ({
  connected,
  member,
  isFromNav = false,
  aloneMember = false,
  onClick,
}: Props) => {
  const { activeVoiceChannel } = useLivekitRTCState();

  const { theater, notConnected, isSpeaking, hasVideo, noTheater } =
    useMemberVariables({ member, connected, aloneMember });

  if (!member) return null;

  return (
    <div
      className={cn('grid-item', {
        theater,
        notConnected,
        hasVideo,
      })}
      onClick={() => onClick && onClick()}
    >
      <MemberCard
        id={`meet_${member.meetId || member.socketId}`}
        className={cn({
          connected,
          isSpeaking,
          hasVideo,
          theater,
          isFromNav,
          aloneMember,
          isP2P: activeVoiceChannel?.channel?.p2p,
          muted: member.muted,
          deaf: member.deaf,
          raisedHand: member.raisedHand,
          noTheater,
        })}
      >
        <TopAbsoluteButtons
          member={member}
          isFromNav={isFromNav}
          connected={connected}
          aloneMember={aloneMember}
        />

        <MemberContent
          member={member}
          connected={connected}
          isFromNav={isFromNav}
          aloneMember={aloneMember}
        />

        {!isFromNav && (
          <MemberInfoContent
            member={member}
            connected={connected}
            aloneMember={aloneMember}
          />
        )}
      </MemberCard>
    </div>
  );
};
